import type { ReactNode } from 'react'

interface AuthLayoutProps {
  children: ReactNode
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/50 p-4">
      <div className="w-full max-w-md">
        {/* Logo and branding */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold tracking-tight">
            <span className="text-primary">Plane</span>
            <span className="text-muted-foreground">MAX</span>
          </h1>
          <p className="text-muted-foreground mt-2">
            FBO Hangar Management Platform
          </p>
        </div>

        {/* Auth form container */}
        {children}
      </div>
    </div>
  )
}
